import React, { useRef, useEffect } from 'react';

import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles /*useTheme*/ } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import Header from '../common-header/Header';
import cornerLogo from '../../assets/cornerLogo.svg';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 10
  },
  headerCont: {
    width: '100%'
  },
  navCont: {
    padding: '1.5rem'
  },
  logoCont: {
    width: '11%',
    height: '40px',
    marginLeft: '60px'
  },
  playButtonCont: {
    height: '50px',
    borderRight: '1px solid rgba(250,250,250,.6)',
    paddingRight: '1.7rem'
  },
  playButton: {
    ...theme.typography.button,
    color: '#fff',
    marginTop: '.9rem'
  },
  linksCont: {
    width: '65%',
    marginLeft: 'auto'
  },
  singleLink: {
    width: '12%',
    color: '#fff',
    textDecoration: 'none'
  },
  navText1: {
    ...theme.typography.navTab1,
    textTransform: 'none',
    width: '100%',
    textAlign: 'left',
    color: '#fff'
  },
  navTextTransparent: {
    ...theme.typography.navTab1,
    textTransform: 'none',
    width: '100%',
    textAlign: 'left',
    color: 'rgba(255, 255, 255, 0.5)'
  },
  label3: {
    ...theme.typography.label3,
    textTransform: 'none',
    width: '100%',
    textAlign: 'left',
    color: '#fff'
  },
  label3Transparent: {
    ...theme.typography.label3,
    textTransform: 'none',
    width: '100%',
    textAlign: 'left',
    color: 'rgba(255, 255, 255, 0.6)'
  }
}));

const navInfo = [
  {
    vidNum: 1,
    text1: 'Alabama',
    text2: 'EPISODE 1',
    released: true,
    link: '#alabama'
  },
  {
    vidNum: 2,
    text1: 'North Carolina',
    text2: 'EPISODE 2',
    released: true,
    link: '#northCarolina'
  },
  {
    vidNum: 3,
    text1: 'Virginia',
    text2: 'EPISODE 3',
    released: true,
    link: '#virginia'
  },
  {
    vidNum: 4,
    text1: 'Georgia',
    text2: 'EPISODE 4',
    released: true,
    link: '#georgia'
  },
  {
    vidNum: 5,
    text1: 'Tennessee',
    text2: 'EPISODE 5',
    released: true,
    link: '#tennessee'
  },
  {
    vidNum: 6,
    text1: 'Mississippi',
    text2: 'EPISODE 6',
    released: true,
    link: '#mississippi'
  }
];

const Navbar = () => {
  const classes = useStyles();
  //   const theme = useTheme();
  //   const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  let containerRef = useRef(null);

  useEffect(() => {
    const showAnim = gsap
      .from(containerRef, {
        yPercent: -100,
        paused: true,
        duration: 0.2
      })
      .progress(1);
    ScrollTrigger.create({
      trigger: containerRef,
      start: 'top top',
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse();
      }
    });
  });
  return (
    <>
      <Grid
        ref={(el) => {
          containerRef = el;
        }}
        container
        direction="column"
        className={classes.wrapper}
      >
        <Header />
        <Grid
          container
          alignItems="center"
          justifyContent="space-evenly"
          className={classes.navCont}
        >
          <Grid container item className={classes.logoCont}>
            <Button>
              <a href="#home">
                <img src={cornerLogo} alt="blind angels logo" style={{ width: '100%' }} />
              </a>
            </Button>
          </Grid>

          <Grid
            container
            justifyContent="space-around"
            alignItems="flex-start"
            className={classes.linksCont}
          >
            <Grid item className={classes.playButtonCont}>
              <Typography className={classes.playButton}>
                <a href="#trailer">Play Trailer</a>
              </Typography>
            </Grid>
            {navInfo.map((link) => (
              <Grid
                key={link.vidNum}
                container
                justifyContent="center"
                className={classes.singleLink}
              >
                <a href={link.link}>
                  <Grid container>
                    <Typography
                      className={
                        link.released === true ? classes.label3 : classes.label3Transparent
                      }
                    >
                      {link.text2}
                    </Typography>
                    <Typography
                      className={
                        link.released === true ? classes.navText1 : classes.navTextTransparent
                      }
                      style={{ width: '100%' }}
                    >
                      {link.text1}
                    </Typography>
                  </Grid>
                </a>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Navbar;
